module.exports = __webpack_public_path__ + "img/va.d6ee6901.svg";